import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import BaseTable from "@/components-UI/table/BaseTable.vue";
import { ITableHeader } from "@/utils";
import { Offer } from "@/services/offers/Offer";
import { CellsType, prepareItems, RawConfig } from "@/utils/CellsFactory";
import { translateAdvertiserStatus, translateChecker } from "@/utils/translate";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvertisersTable',
  props: {
    items: null,
    limit: null,
    total: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    items: Offer[],
    limit: number,
    total: number,
    loading: boolean,
}



const headers: ITableHeader[] = [
    { text: 'ID', value: 'id', align: 'center' },
    { text: 'Название', value: 'name' },
    { text: 'Аккаунт-менеджер', value: 'account_manager' },
    { text: 'Чеккер', value: 'is_checker_used' },
    { text: 'Статус', align: 'center', value: 'status' },
];
const tableConfig: RawConfig<any> = {
    [CellsType.Route]: {
        id: {
            name: 'advertiser',
            valueKey: 'id',
            isChip: true,
            text: 'id',
        },
        name: {
            name: 'advertiser',
            valueKey: 'id',
            text: 'name',
        },
    },
    [CellsType.Status]: {
        is_checker_used: {
            translate: (status) => translateChecker(status as boolean),
        },
        status: {
            translate: (status) => translateAdvertiserStatus(status as string),
        },
    },
    [CellsType.Uniq]: {
        account_manager: {},
    },
};
const tableItems = ref([]);

const prepareTable = (): void => {
    const columns = headers.map(h => h.value);
    const items = props.items.map(el => ({
        ...el,
        ...{
            is_checker_used: el.is_checker_used === null ? false : el.is_checker_used,
        },
    }));
    tableItems.value = prepareItems(items, tableConfig, columns);
};

watch(() => props.items.length, () => {
    prepareTable();
}, { immediate: true, deep: true });

return { __sfc: true,props, headers, tableConfig, tableItems, prepareTable, BaseTooltip, BaseTable }
}

})